import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

const DEFAULT_TIMEOUT_SECS = 20;

export default function ManagersDecisionModal({ eligibleCards, onPick, timeoutSecs }) {
  const effectiveTimeout = timeoutSecs > 0 ? timeoutSecs : DEFAULT_TIMEOUT_SECS;
  const [selected, setSelected] = useState(null);
  const [timeLeft, setTimeLeft] = useState(effectiveTimeout);
  const autoFiredRef = useRef(false);

  useEffect(() => {
    if (!eligibleCards?.length) return;
    setTimeLeft(effectiveTimeout);
    autoFiredRef.current = false;
    const first = eligibleCards[0]?.id;
    const id = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          if (!autoFiredRef.current) {
            autoFiredRef.current = true;
            onPick(first);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-slate-900 border border-red-500/40 rounded-2xl p-5 w-full max-w-sm mx-4 shadow-2xl"
      >
        <div className="mb-4">
          <div className="flex items-center justify-between mb-1">
            <p className="text-[10px] font-black tracking-widest text-red-400 uppercase">Manager's Decision</p>
            <span className={`text-xs font-black tabular-nums ${timeLeft <= 5 ? "text-red-400 animate-pulse" : "text-slate-400"}`}>
              {timeLeft}s
            </span>
          </div>
          <p className="text-sm text-slate-400">Choose one opponent active card to discard.</p>
        </div>

        <div className="space-y-2 mb-5">
          {eligibleCards.map(({ id, name }) => {
            const isSelected = selected === id;
            return (
              <button
                key={id}
                onClick={() => setSelected(id)}
                className={`w-full text-left rounded-xl border p-3 transition-all ${
                  isSelected
                    ? "border-red-500/70 bg-red-500/15"
                    : "border-slate-700 bg-slate-800/60 hover:border-slate-500"
                }`}
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="text-sm font-black text-white">{name}</span>
                  {isSelected && (
                    <span className="text-[8px] font-black px-1.5 py-0.5 rounded bg-red-500/20 border border-red-500/40 text-red-300 uppercase tracking-wider">
                      Target
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <button
          onClick={() => selected && onPick(selected)}
          disabled={!selected}
          className="w-full py-3 rounded-xl bg-red-600 hover:bg-red-500 text-white font-black text-sm transition disabled:opacity-40"
        >
          {selected ? "Discard This Card →" : "Select a card to discard"}
        </button>
      </motion.div>
    </div>
  );
}
